import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { log } from 'console';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-open-college-addmission',
  templateUrl: './open-college-addmission.component.html',
  styleUrls: ['./open-college-addmission.component.scss']
})
export class OpenCollegeAddmissionComponent implements OnInit {
  SessionCutOffList: any;
  totalItems: any;
  message: string;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  OpenAdmSearchForm
  districtList: any;
  filteredListdistrictCode: any;
  collegedataList=[];
  filteredListCollege=[];
  districCode: any;
  constructor(private fb: FormBuilder, private modalPopupService: ModalpopService,
    public umsService: UmsService, private spinner: NgxSpinnerService) { }
  dialogRef: MatDialogRef<any>;
  openAddmision: FormGroup;
  saveBtn = false;
  AdmClosed = false
  ngOnInit(): void {
    sessionStorage.getItem('loginId');
    this.fetchAllSessionCutoff()
    this.getCuttoffDate();
    this.getDistrictData();

    this.OpenAdmSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
    this.openAddmision= this.fb.group({
      
      StuDistrictAd: new FormControl(''),
      StuStudyCenter: new FormControl(''),
    });
  }


  fetchAllSessionCutoff() {
    this.spinner.show();
    const payload = {};
    // payload['PageSize'] = this.pageSize;
    // sessionStorage.getItem('session');
    payload['SnNo'] = sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = ''
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['DsCode'] = '';
    payload['CgCode'] = '';
    let today1 = new Date().setHours(0, 0, 0, 0);
    let today = new Date();
    const newDataArray: any[] = [];
    let newData = [];
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    let day = String(today.getDate()).padStart(2, '0');
    let todaYDate = `${year}-${month}-${day}`;

    this.umsService.listSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SessionCutOffList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.SessionCutOffList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }

  
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.fetchAllSessionCutoff();
    this.keypress();
  }


  keypress() {
    this.SessionCutOffList = [];
    let payload = {}
    payload['SnNo'] = sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = this.OpenAdmSearchForm.value['SearchString'];
    payload['PageSize'] = this.pageSize;
    // payload['PageNumber'] = this.currentPage;
    if (payload['SearchString'] === "") {
      payload['PageNumber'] = this.currentPage;
    } else {
      payload['PageNumber'] = 1;
    }
    this.umsService.SearchSessionCutOff(payload).subscribe(res => {
      if(res.status){
        this.SessionCutOffList  = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }
      else{
        this.SessionCutOffList = [];
        this.totalItems = 0;
      }
     
    }, (ERROR: HttpErrorResponse) => {
      this.SessionCutOffList = [];
    });
  }
  submit(data) {
    this.spinner.show();
    const payload = {};
    // payload['PageSize'] = this.pageSize;
    payload['LoginId'] = sessionStorage.getItem('loginId');
    payload['College'] = data.CoCgCgCode;
    payload['Course'] = data.CoCgCoCode;
    payload['FromDate'] = data.FromDate;
    payload['ToDate'] = data.ToDate;
    payload['Status'] = 'Y';
    this.umsService.applyDate(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.spinner.hide
        let data = {};
        data['message'] = "Applied Succesfully";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.saveBtn = true;
        this.dialogRef.afterClosed().subscribe((result) => {
          var link = document.createElement('a');
          link.setAttribute("href", "/student-registration-tab");
          link.click()
        });

      } else {
        this.spinner.hide
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }

  openConformationModalBox(data1) {
    let data = {}
    data['message'] = 'Are You Sure You Want To Take Addmision For College ' + data1.CgName + ' And For Course ' + data1.CoName + '.'
    data['title'] = 'Information'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.submit(data1)
      } else {
        // this.next.emit();

        this.ngOnInit()
      }
    });
  }

  getCuttoffDate() {
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getCuttoffDate(payload).subscribe((res) => {
      if (res.status) {
        this.saveBtn = true;
      } else {
        this.saveBtn = false;
      }
    })
  }

  getDistrictData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.districtList = res.data;
        this.filteredListdistrictCode = this.districtList.slice();
      }
      else{
        this.spinner.hide();
        this.districtList = []
      }
    
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getCollegeData(dsCode) {
    this.collegedataList =[];
    this.filteredListCollege=[]
    this.spinner.show();
    const payload = {};
    payload['DsCode'] = dsCode;
    this.fetchAllSessionCutoff2(dsCode)
    this.openAddmision.get('StuStudyCenter').reset();
    this.umsService.DistrictWiseCollege(payload).subscribe((res) => {
      if(res.status){
        this.spinner.hide();
        this.collegedataList = res.data;
        this.filteredListCollege = this.collegedataList.slice();
   
      }
      else{
        this.spinner.hide();
        this.collegedataList =[];
        this.filteredListCollege=[]
      }
       
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }



  fetchAllSessionCutoff2(dsCode) {
    this.spinner.show();
    const payload = {};
    this.districCode = dsCode
    payload['SnNo'] = sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = ''
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['DsCode'] = dsCode;
    payload['CgCode'] = '';
    let today1 = new Date().setHours(0, 0, 0, 0);
    let today = new Date();
    const newDataArray: any[] = [];
    let newData = [];
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    let day = String(today.getDate()).padStart(2, '0');
    let todaYDate = `${year}-${month}-${day}`;

    this.umsService.listSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SessionCutOffList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.SessionCutOffList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }

  fetchAllSessionCutoff3(CgCode) {
    this.spinner.show();
    const payload = {};
    // payload['PageSize'] = this.pageSize;
    // sessionStorage.getItem('session');
    payload['SnNo'] = sessionStorage.getItem('session');
    payload['InCode'] = 'ADM'
    payload['SearchString'] = ''
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['DsCode'] = this.districCode;
    payload['CgCode'] = CgCode;
    let today1 = new Date().setHours(0, 0, 0, 0);
    let today = new Date();
    const newDataArray: any[] = [];
    let newData = [];
    let year = today.getFullYear();
    let month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    let day = String(today.getDate()).padStart(2, '0');
    let todaYDate = `${year}-${month}-${day}`;

    this.umsService.listSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.SessionCutOffList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      } else {
        this.SessionCutOffList = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SessionCutOffList = [];
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(
        AlertboxComponent,
        data
      );
    });
  }
}